import { useSlackCRUDActions } from '@mm/state/actions/SlackCRUDActions';
import { SlackAccount } from '@mm/state/model/SlackModel';
import { selectSlackAccounts } from '@mm/state/selectors/slackSelectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

export const useConnectSlack = () => {
  const [oauthUrl, setOauthUrl] = useState('');
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const slackAccounts = useSelector(selectSlackAccounts);

  const { getOauthUrl } = useSlackCRUDActions();
  const { getAccounts } = useSlackCRUDActions();

  const connectSlack = useCallback(async () => {
    const link = await getOauthUrl(window.location.href);
    if (link) {
      setOauthUrl(link);
      window.open(link, '_self');
    }
  }, [getOauthUrl]);

  const retrieveSlackAccounts = () => {
    getAccounts(facebookPageId);
  };

  return {
    oauthUrl,
    connectSlack,
    retrieveSlackAccounts,
    slackAccounts,
  };
};
